/**
 * BOTTOM GENERAL INITS
 * quiz
 */

import { QuizQuestions } from "./quiz-questions";


export class QuizInits {

    // Variable para generar nueva distribución
    doc = $(document);

    constructor() {
        this.initMap();
    }

    initMap() {
        new QuizQuestions();
    }
}
